import React from 'react';

import { cn } from '@/shared/classnames';

type CardProps<TElementType extends React.ElementType = 'div'> = {
  as?: TElementType;
} & Omit<React.ComponentPropsWithoutRef<TElementType>, 'as'>;

export function Card({ as: Component = 'div', className, ...props }: CardProps) {
  return <Component className={cn('flex rounded-lg bg-white shadow-sm p-4', className)} {...props} />;
}
